<script>
import {fetchChannelName} from "@/api/homepage.api";

export default {
	name: "TwitchPlayer",
	data() {
		return {
			src: 'https://embed.twitch.tv/embed/v1.js',
			channelName: null,
			parent: window.location.hostname
		}
	},
	created() {
		const fetchResponse = fetchChannelName();
		new Promise((resolve, reject) => {
			let script = document.querySelector(`script[src="${this.src}"]`)

			if(!script){
				script = document.createElement('script')
				script.src = this.src;
				script.async = true;
				script.setAttribute('data-status', 'loading')
				document.head.append(script)
			}

			script.addEventListener('load', () => {
				resolve();
				script.setAttribute('data-status', 'loaded')
			})

			script.addEventListener('error', () => {
				reject()
			})
		}).then(() => {
			fetchResponse.then((response) => {
				const channelName = response.data.channel;
				this.channelName = channelName;

				new Twitch.Embed("player", {
					width: '100%',
					height: '100%',
					channel: channelName,
					layout: 'video',
					parent: [this.parent]
				});
			})
		}).catch((err) => {
				console.log('An error occured', err)
		})
	},
}
</script>

<template>
	<div id="frame">
		<div id="player" style="height: 100vh;width: 100vw;overflow: hidden;"></div>
	<!-- <iframe -->
	<!-- 	v-if="channelName && channelName.length > 0" -->
	<!-- 	id='frame' -->
	<!-- 	:src="`https://player.twitch.tv/?channel=${channelName}&parent=${parent}&autoplay=true`" -->
	<!-- 	frameborder='0' -->
	<!-- 	scrolling='no' -->
	<!-- 	allowfullscreen='true' -->
	<!-- > -->
	<!-- </iframe> -->
	</div>
</template>

<style lang="scss">

#frame {
	height: 100vh;
	width: 100vw;
}

.container {
	padding: 0;
}

</style>
